import React, { useEffect } from 'react'
import { CardContainer_Props } from './interface'
import { PlaceholderWrapper, Placeholder } from './GameBoardStyles'
import { Card } from '../card/Card'
import { Cardback, CardWrapper } from '../card/CardStyles'
import { colors } from 'lib/colors'
// import useSound from 'use-sound'
// import dealSFX from '../../lib/assets/audio/dealCards.mp3'

export default function DealerContainer({
  cardsList,
  deal,
  dealOut,
  flipCard,
  calculateDelay,
  showResult,
  winPositions,
  noAnimate,
  delay,
}: CardContainer_Props) {
 
  return (
    <PlaceholderWrapper className='dealer' noAnimate={noAnimate}>
      {cardsList.map((card: any, id: any) => (
        <Placeholder key={id} zIndex={2 - id}>
          <CardWrapper
            deal={deal}
            flipCard={flipCard}
            dealOut={dealOut}
            noAnimate={noAnimate}
            delay={delay}
          >
            {noAnimate && card === 'X0'
              ? ''
              : deal && (
                  <>
                    <Card
                      noAnimate={noAnimate}
                      card={card}
                      deal={deal}
                      flipCard={flipCard}
                      animDelay={calculateDelay(id + 2)}
                      background={
                        showResult && winPositions[id] === '1'
                          ? colors.secondary
                          : colors.cardWhite
                      }
                    />
                  </>
                )}
            {deal && (
              <Cardback
                className='back'
                deal={deal}
                flipCard={flipCard}
                animDelay={calculateDelay(id + 2)}
                showBack={card !== 'X0'}
                noAnimate={noAnimate}
              />
            )}
          </CardWrapper>
        </Placeholder>
      ))}
    </PlaceholderWrapper>
  )
}
